//
//
//
//
//
//

export default {
    name: "home"
}



// WEBPACK FOOTER //
// ./src/components/coupon/Home.vue